import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import type { LoadingBackdropOverlayProps } from "./types";
import useLoadingBackdropOverlayContext from "./useLoadingBackdropOverlayContext";

const LoadingBackdropOverlay = ({ slotProps, ...restProps }: LoadingBackdropOverlayProps) => {
    const { open } = useLoadingBackdropOverlayContext();

    return (
        <Backdrop
            {...restProps}
            sx={{
                color: theme => theme.palette.common.white,
                ...restProps.sx
            }}
            open={open}
        >
            <CircularProgress
                color='inherit'
                {...slotProps?.circularProgress}
            />
        </Backdrop>
    );
};

export default LoadingBackdropOverlay;
